class Box {
	constructor({
		id = '',
		code = '',
		name = '',
		widthCm = 0,
		heightCm = 0,
		depthCm = 0,
		tareKg = 0,
		useYn = 1,
		memo = '',
		productCount = 0,
		updatedAt = '',
		updatedBy = '',
		createdAt = '',
		createdBy = '',
	} = {}) {
		this.id = id === null ? '' : id
		this.code = code === null ? '' : code
		this.name = name === null ? '' : name
		this.widthCm = widthCm === null ? 0 : Number(widthCm)
		this.heightCm = heightCm === null ? 0 : Number(heightCm)
		this.depthCm = depthCm === null ? 0 : Number(depthCm)
		this.tareKg = tareKg === null ? 0 : Number(tareKg)
		this.useYn = useYn === null ? 1 : Number(useYn)
		this.memo = memo === null ? '' : memo
		this.productCount = productCount === null ? 0 : Number(productCount)
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.updatedBy = updatedBy === null ? '' : updatedBy
		this.createdAt = createdAt === null ? '' : createdAt
		this.createdBy = createdBy === null ? '' : createdBy
	}
	id: string
	code: string
	name: string
	widthCm: number
	heightCm: number
	depthCm: number
	tareKg: number
	useYn: number
	memo: string
	productCount: number
	updatedAt: string
	updatedBy: string
	createdAt: string
	createdBy: string
}

class ProductPackaging {
	constructor({
		id = '',
		code = '',
		name = '',
		useYn = 1,
		boxId = '',
		boxCode = '',
		netKg = null as number | null,
	} = {}) {
		this.id = id === null ? '' : id
		this.code = code === null ? '' : code
		this.name = name === null ? '' : name
		this.useYn = useYn === null ? 1 : Number(useYn)
		this.boxId = boxId === null ? '' : boxId
		this.boxCode = boxCode === null ? '' : boxCode
		this.netKg = netKg === null || netKg === undefined ? null : Number(netKg)
	}
	id: string
	code: string
	name: string
	useYn: number
	boxId: string
	boxCode: string
	netKg: number | null
}

export { Box, ProductPackaging }
